import React, { useState } from 'react';
import API from '../../../../utils/api';
import Iconify from '../../../Iconify';
import usePaymentStore from '../../shared/store/use-payment-store';
import { showModalError } from '../../shared/components/modals/modal-error';
import { waitUserCancelCashoutsPending } from '../../shared/utils/cashouts';
import styles from './cash.module.css';
import iconoTienda from '../../shared/assets/icono-tienda.png';
import iconoBotonDescargaFicha from '../../shared/assets/icono-boton-descarga-tu-ficha.png';
import iconoDisclaimer from '../../shared/assets/icono-disclaimer.png';

// Assets
import logoSuperFarmacia from '../../shared/assets/store-logos/super-farmacia.png';
import logoWalmart from '../../shared/assets/store-logos/walmart.png';
import logoWalmartExpress from '../../shared/assets/store-logos/walmart-express.png';
import logoWaldos from '../../shared/assets/store-logos/waldos-1.png';
import logoVia from '../../shared/assets/store-logos/via.png';
import logoSysTienda from '../../shared/assets/store-logos/sys-tienda.png';
import logo7Eleven from '../../shared/assets/store-logos/7-eleven.png';
import logoFarmaciasAhorro from '../../shared/assets/store-logos/farmacias-del-ahorro.png';
import logoK from '../../shared/assets/store-logos/k.png';
import logoKiosko from '../../shared/assets/store-logos/kiosko.png';
import logoPagaqui from '../../shared/assets/store-logos/pagaqui.png';
import logoSamsClub from '../../shared/assets/store-logos/sams-club.png';
import logoEleczion from '../../shared/assets/store-logos/eleczion.png';
import logoExtra from '../../shared/assets/store-logos/extra.png';
import logoCircleK from '../../shared/assets/store-logos/circle-k.png';
import logoBodegaAurrera from '../../shared/assets/store-logos/bodega-aurrera.png';

const getPdfUrl = reference => {
  return process.env.NODE_ENV === 'production'
    ? `https://dashboard.openpay.mx/paynet-pdf/myabfqccohuj4kszwr7y/${reference}`
    : `https://sandbox-dashboard.openpay.mx/paynet-pdf/mqfki2pbqpbve54kabor/${reference}`;
};

export const CashOpenpay = () => {
  const { amount, isInvalidAmount } = usePaymentStore();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [order, setOrder] = useState(null);

  const processPayment = async () => {
    setIsSubmitting(true);
    try {
      const userCancell = await waitUserCancelCashoutsPending({
        buttonConfirm: 'Generar Referencia',
        buttonCancel: 'Cancelar',
      });

      if (userCancell) {
        setIsSubmitting(false);
        return;
      }

      const data = {
        amount: 'other',
        other_amount: amount,
        method: 'convenience',
      };

      const response = await API.postDepositConvenience(data);

      if (response?.data?.success) {
        let pdfUrl = getPdfUrl(response.data.response.payment_method.reference);
        setOrder({ ...response.data.response, pdfUrl });
      } else {
        showModalError({ errorMessage: response.data.error });
      }
    } catch (error) {
      showModalError({ errorMessage: 'Ha ocurrido un error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      {!order && (
        <div className={styles.container}>
          {/* Header con icono y título */}
          <div className={styles.header}>
            <div className={styles.headerIcon}>
              <img src={iconoTienda} alt="Icono pago en tienda" />
            </div>
            <h2 className={styles.headerTitle}>
              Genera tu ficha de depósito{' '}
              <span className={styles.headerTitleHighlight}>para pago en tiendas.</span>
            </h2>
          </div>

          {/* Botón de acción */}
          <div className={styles.buttonContainer}>
            <button
              className="payment-button"
              onClick={processPayment}
              disabled={isSubmitting || isInvalidAmount}
            >
              <span className={styles.buttonText}>Generar tu ficha</span>
              <img
                src={iconoBotonDescargaFicha}
                alt="Icono descargar ficha"
                className={styles.buttonIcon}
              />
            </button>
          </div>

          {/* Logos de tiendas */}
          <div className={styles.storesGrid}>
            <div className={styles.storeLogo}>
              <img src={logoSuperFarmacia} alt="Super Farmacia" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoWalmart} alt="Walmart" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoWalmartExpress} alt="Walmart Express" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoWaldos} alt="Waldo's" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoVia} alt="VIA" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoSysTienda} alt="SYStienda" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logo7Eleven} alt="7-ELEVEN" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoFarmaciasAhorro} alt="Farmacias del Ahorro" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoK} alt="K" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoKiosko} alt="KIOSKO" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoPagaqui} alt="Pagaqui" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoSamsClub} alt="Sam's Club" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoEleczion} alt="elecZion" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoExtra} alt="Extra" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoCircleK} alt="CIRCLE K" />
            </div>
            <div className={styles.storeLogo}>
              <img src={logoBodegaAurrera} alt="Bodega Aurrera" />
            </div>
          </div>

          {/* Advertencia */}
          <div className={styles.warningBox}>
            <img src={iconoDisclaimer} alt="Icono advertencia" className={styles.warningIcon} />
            <div className={styles.warningContent}>
              <div className={styles.warningTitle}>¡RECUERDA!</div>
              <div className={styles.warningText}>
                Los depósitos en tienda pueden tomar hasta 3 horas en verse el saldo reflejado en
                tu cuenta.
              </div>
            </div>
          </div>

          <div className={styles.secondaryText}>
            <a
              href="https://www.paynet.com.mx/mapa-tiendas/index.html"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.storesLink}
            >
              Consulta las tiendas participantes.
            </a>
          </div>
        </div>
      )}

      {order && (
        <div className={styles.orderInfo}>
          <p className={styles.warningText}>
            Gracias por tu compra, acude a tu tienda más cercana y presenta este código de barras:
          </p>

          <div className="text-center">
            <img
              src={order.payment_method.barcode_url}
              className={`${styles.barcodeImage}`}
              alt="Código de barras"
            />
          </div>
          <div className={styles.reference}>{order.payment_method.reference}</div>
          <div className="text-center mb-2">Código para abonar ${amount} MXN </div>
          <div className="text-center text-bold mt-5" style={{ color: '#c7ae0d' }}>
            <a
              href="https://www.paynet.com.mx/mapa-tiendas/index.html"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.mapLink}
            >
              Consulta el mapa de tiendas para realizar tu pago.
            </a>
            <br />
            <a
              href="https://www.paynet.com.mx/mapa-tiendas/index.html"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.mapLink}
            >
              <Iconify
                icon="streamline-flex:map-location-solid"
                style={{ fontSize: '2em', color: '#70c70d', margin: '1rem' }}
              />
            </a>
          </div>

          <button
            className="payment-button"
            onClick={() => window.open(order.pdfUrl, '_blank')}
          >
            <span className={styles.buttonText}>Descarga tu ficha</span>
            <img
              src={iconoBotonDescargaFicha}
              alt="Icono descargar ficha"
              className={styles.buttonIcon}
            />
          </button>
        </div>
      )}
    </div>
  );
};
